export default "__VITE_ASSET__WWoo4glb__"